import React from 'react';
import PropTypes from 'prop-types';

import Modal from '../shared/modals/modal.component';

const CannotCalculateMessageModal = ({ hideModal, isVisible }) => (
  <Modal
    className="calculate-message-modal"
    dismissText="Close"
    closeAction={hideModal}
    dismissAction={hideModal}
    isVisible={isVisible}
  >
    <div>
      Unable to calculate a tax provision. Prior to calculating a tax provision, the following must occur:
      <ul>
        <li>An entity must be chosen from the list of available tax provisions.</li>
        <li>The period selected must be the current period.</li>
        <li>A trial balance must exist without errors.</li>
        <li>The provision must not be associated with a connection.</li>
      </ul>
    </div>
  </Modal>
);

CannotCalculateMessageModal.propTypes = {
  hideModal: PropTypes.func.isRequired,
  isVisible: PropTypes.bool,
};

export default CannotCalculateMessageModal;
